import { useProjectsStore } from "@/stores/projects"
import { useQrsTableStore } from "@/stores/qrs"
import { useUserAccountsStore } from "@/stores/userAccounts"

class ChangeWorkSpace {
  static async apply(value) {
    const userAccountsStore = useUserAccountsStore()

    await userAccountsStore.changeWorkSpace(value)
    await Promise.all([useQrsTableStore().fetchData(), useProjectsStore().fecthProjects()])
  }
}

export default ChangeWorkSpace
